"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.UNSORTED = exports.DESCENDING = exports.ASCENDING = void 0;

var _react = _interopRequireDefault(require("react"));

var _getNextInCircularArray = _interopRequireDefault(require("../../../utils/getNextInCircularArray"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ASCENDING = 'ascending';
exports.ASCENDING = ASCENDING;
var DESCENDING = 'descending';
exports.DESCENDING = DESCENDING;
var UNSORTED = 'unsorted';
exports.UNSORTED = UNSORTED;
var SORT = 'SORT';
var sortingTypes = [ASCENDING, DESCENDING, UNSORTED];

function sortReducer(state, action) {
  switch (action.type) {
    case SORT:
      {
        // When the current column is sorted again, it will cycle through the sortingTypes.
        if (action.column === state.sortingColumn) {
          return _objectSpread({}, state, {
            sortingType: (0, _getNextInCircularArray.default)(sortingTypes, state.sortingType)
          });
        } // When a new column is chosen, it should always start at the beginning of the sortingTypes.


        return _objectSpread({}, state, {
          sortingColumn: action.column,
          sortingType: sortingTypes[0]
        });
      }

    default:
      {
        throw new Error("[sortReducer] UNHANDLED ACTION: ".concat(action.type));
      }
  }
}
/**
 * This React hook is used to set up sortable columns in the table context provider.
 * @returns {UseSortableHeaders}
 */


function useSortableHeaders() {
  var defaultSort = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _React$useReducer = _react.default.useReducer(sortReducer, defaultSort),
      _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
      state = _React$useReducer2[0],
      dispatch = _React$useReducer2[1];

  var sort = function sort(column) {
    return dispatch({
      type: SORT,
      column: column
    });
  };

  return _objectSpread({}, state, {
    sort: sort
  });
}

var _default = useSortableHeaders;
exports.default = _default;